module.exports = __webpack_public_path__ + "f6d987ca.png";